import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import ResponsiveDrawer from "@/components/common/layout";

const ProtectedRoute = () => {
  const location = useLocation();
  let isAuthenticated = localStorage.getItem("isAuthenticated") === "true";

  // ⛔️ Removed useAutoLogout (no timer-based logout)

  if (isAuthenticated && location.pathname === "/") {
    return <Navigate to="/dashboard" replace />;
  }

  return isAuthenticated ? <ResponsiveDrawer /> : <Navigate to="/login" />;
};

export default ProtectedRoute;
